/** Resolve signed-in user email for audit timeline defaults. */
export function getCurrentAuditActorEmail(): string {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const user = JSON.parse(raw) as { email?: string; Email?: string };
      const email = user.email?.trim() || user.Email?.trim();
      if (email) return email;
    }
  } catch {
    /* ignore */
  }

  try {
    const token = localStorage.getItem('ap_idToken');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))) as {
        email?: string;
      };
      if (payload.email?.trim()) return payload.email.trim();
    }
  } catch {
    /* ignore */
  }

  return '';
}
